import { faStrikethrough } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import useSWR from "swr";
import apiService from "./ApiService";
import {Image, ImageType} from "../models/image";

function useProductDetail(sku: string) : {productDetails:any, isLoading:boolean, error:any}{
  const {data, error} = useSWR('/product-detail/' + sku, () => apiService.get(`api/products/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return {
        productDetails: data,
          isLoading: !data && !error,
          error
      };
};

function useProductImages(sku: string, imageType: ImageType) : {productImages:Image[]} {
  var highResolution = imageType === ImageType.HighResolution;
  const {data, error} = useSWR('/product-images/' + sku + '/' + highResolution, () => apiService.get(`api/products/images/` + sku, { highResolution: highResolution}).then((res) => 
      res.data.map((item: any) => { 
        return {
          ImageId: item.id,
          DisplayOrder: item.displayOrder,
          LastModified: item.lastModified,
          FileName: item.title,
          ImageUrl: item.main,
          Thumbnail: item.thumbnail,
          HighResolution: item.highResolution,
          Blob: item.blob,
          IsChecked: item.isChecked || false
        };
    })
  ), {shouldRetryOnError: false});

  return {
    productImages: data
  };
};

function useAttributes(sku: string) : any{
  const {data, error} = useSWR('/attributes/' + sku, () => apiService.get(`api/products/attributes/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return data;
};

function useInventories(sku: string) : any{
  const {data, error} = useSWR('/inventories/' + sku, () => apiService.get(`api/products/inventories/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return data;
};

function useMarketingSentence(sku: string) : any{
  const {data, error} = useSWR('/marketing-sentence/' + sku, () => apiService.get(`api/products/marketing-sentence/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return data;
};

function useRelatedProducts(sku: string) : any{
  const {data, error} = useSWR('/related-products/' + sku, () => apiService.get(`api/products/related-products/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return data;
};

function useDescription(sku:string): any{
  const {data, error} = useSWR('/description/' + sku, () => apiService.get(`api/products/description/` + sku).then((res) => res.data), {shouldRetryOnError: false});

      return data;
};

function GetWatermarkOptions(sku: string) : any {
  const {data, error} = useSWR(`api/images/${sku}/watermarktypes`, () => apiService.get(`api/images/${sku}/watermarktypes`).then((res) => res.data), {shouldRetryOnError: false});
  return {
    data,
    isLoading: !data && !error
  };
};

function DownloadImages(params: any) : any{
  return apiService.downloadFile(`api/images/download`, params).then((res) => res.data);
};

function DownloadHighResImages(params: any) : any{
  return apiService.downloadFile(`api/images/download-highres`, params).then((res) => res.data);
};

export {useProductDetail, useProductImages, useAttributes, useInventories, useMarketingSentence, useRelatedProducts, DownloadImages, DownloadHighResImages, useDescription, GetWatermarkOptions};
